export default class SpinocoChat {
    public static init(): void {
        this.handleSpinocoChat();
    }

    static handleSpinocoChat(): void {
        if (window.innerWidth <= 991) {
            this.handleMobileChat();
        } else {
            this.handleDesktopChat();
        }
    }

    static handleMobileChat(): void {
        const mobileChatBtn = document.querySelector('.bottom-bar__messenger');
        if (mobileChatBtn) {
            mobileChatBtn.addEventListener('click', () => {
                let spinocoScript = document.querySelector('script[data-spinoco-src]') as HTMLScriptElement | null;
                const scriptSrc = spinocoScript ? spinocoScript.getAttribute('data-spinoco-src') : null;

                if (scriptSrc && (!spinocoScript || !spinocoScript.hasAttribute('src'))) {
                    if (!spinocoScript) {
                        spinocoScript = document.createElement('script');
                        spinocoScript.setAttribute('data-spinoco-src', scriptSrc);
                        document.body.appendChild(spinocoScript);
                    }

                    spinocoScript.setAttribute('src', scriptSrc);
                    spinocoScript.addEventListener('load', () => {
                        this.checkElementsAndOpenChat();
                    });
                } else if (spinocoScript && spinocoScript.hasAttribute('src')) {
                    this.checkElementsAndOpenChat();
                } else {
                    console.error('Skript pro Spinoco chat plugin nebyl nalezen nebo adresa není nastavena');
                }
            });
        } else {
            console.error('Mobilní tlačítko chatu nebylo nalezeno');
        }
    }

    static handleDesktopChat(): void {
        const desktopChatDiv = document.querySelector('#js-spinoco-desktop');
        if (desktopChatDiv) {
            desktopChatDiv.addEventListener('click', () => {
                let spinocoScript = document.querySelector('script[data-spinoco-src]') as HTMLScriptElement | null;
                const scriptSrc = spinocoScript ? spinocoScript.getAttribute('data-spinoco-src') : null;

                if (scriptSrc && (!spinocoScript || !spinocoScript.hasAttribute('src'))) {
                    if (!spinocoScript) {
                        spinocoScript = document.createElement('script');
                        spinocoScript.setAttribute('data-spinoco-src', scriptSrc);
                        document.body.appendChild(spinocoScript);
                    }

                    spinocoScript.setAttribute('src', scriptSrc);
                    spinocoScript.addEventListener('load', () => {
                        console.log('Skript načten při kliknutí');
                        setTimeout(() => {
                            desktopChatDiv.classList.add('not-active');
                            this.triggerChat();
                            }, 100);
                    });
                } else if (spinocoScript && spinocoScript.hasAttribute('src')) {
                    console.error('Skript již byl načten nebo adresa není nastavena');
                    desktopChatDiv.classList.add('not-active');
                    setTimeout(() => this.triggerChat(), 100); // Přidán timeout
                } else {
                    console.error('Skript pro Spinoco chat plugin nebyl nalezen');
                }
            });
        } else {
            console.error('Element s ID "js-spinoco-desktop" nebyl nalezen');
        }
    }

    static triggerChat(): void {
        const trigger = document.querySelector('.swp-trigger') as HTMLElement | null;
        if (trigger) {
            trigger.click();
        } else {
            console.error('Element s třídou "swp-trigger" nebyl nalezen');
            setTimeout(() => this.triggerChat(), 100); // Opakuj, dokud není nalezen
        }
    }

    static checkElementsAndOpenChat(): void {
        const wrapper = document.querySelector('.swp-chat-wrapper') as HTMLElement | null;
        const trigger = document.querySelector('.swp-trigger') as HTMLElement | null;

        if (trigger && wrapper) {
            const originalZIndex = '-1100';
            wrapper.style.setProperty('z-index', '1100', 'important');
            trigger.click();

            const closeButton = document.querySelector('.swp-header-close') as HTMLElement | null;
            if (closeButton) {
                closeButton.addEventListener(
                    'click',
                    () => {
                        wrapper.style.setProperty('z-index', originalZIndex, 'important');
                    },
                    { once: true },
                );
            }
        } else {
            setTimeout(() => this.checkElementsAndOpenChat(), 100);
        }
    }
}
